import { jsx as o, jsxs as S, Fragment as Tr } from "react/jsx-runtime";
import * as _ from "react";
import { forwardRef as Q, useId as ut, useRef as it, useState as nr, useEffect as ur } from "react";
import "react-dom";
function at(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ir = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ar;
function pt() {
  return ar || (ar = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(ir)), ir.exports;
}
var ot = pt();
const pr = /* @__PURE__ */ at(ot), lt = "_rotate_1xozj_1", st = "_dash_1xozj_1", I = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: lt,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: st,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, L = "purpur-spinner", ct = {
  SM: "sm"
}, _t = ({
  ["data-testid"]: t,
  disabled: i = !1,
  negative: n = !1,
  size: p = ct.SM,
  ...a
}) => /* @__PURE__ */ o(
  "div",
  {
    className: pr([I[L], I[`${L}--${p}`]]),
    "data-testid": t,
    ...a,
    children: /* @__PURE__ */ o("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ o(
      "circle",
      {
        className: pr(I[`${L}__circle`], {
          [I[`${L}__circle--disabled`]]: i,
          [I[`${L}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
), dt = {
  LG: "lg"
};
function ft(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var or = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var lr;
function vt() {
  return lr || (lr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(or)), or.exports;
}
var gt = vt();
const sr = /* @__PURE__ */ ft(gt), bt = "_rotate_1xozj_1", mt = "_dash_1xozj_1", E = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: bt,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: mt,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, F = "purpur-spinner", xt = {
  SM: "sm"
}, yt = ({
  ["data-testid"]: t,
  disabled: i = !1,
  negative: n = !1,
  size: p = xt.SM,
  ...a
}) => /* @__PURE__ */ o(
  "div",
  {
    className: sr([E[F], E[`${F}--${p}`]]),
    "data-testid": t,
    ...a,
    children: /* @__PURE__ */ o("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ o(
      "circle",
      {
        className: sr(E[`${F}__circle`], {
          [E[`${F}__circle--disabled`]]: i,
          [E[`${F}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function ht(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var cr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var _r;
function wt() {
  return _r || (_r = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(cr)), cr.exports;
}
var $t = wt();
const jt = /* @__PURE__ */ ht($t), qt = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, St = jt.bind(qt), M = "purpur-button", zt = ({
  children: t,
  className: i,
  ["data-testid"]: n,
  disabled: p = !1,
  fullWidth: a = !1,
  iconOnly: r,
  loading: e = !1,
  negative: u = !1,
  onClick: f,
  size: b = "md",
  variant: v,
  type: O = "button",
  ...$
}, l) => {
  if (r && v === "destructive")
    return null;
  const h = St(
    [
      M,
      `${M}--${u ? `${v}-negative` : v}`,
      `${M}--${b}`
    ],
    {
      [`${M}--icon-only`]: r,
      [`${M}--negative`]: u,
      [`${M}--full-width`]: a,
      [`${M}--disabled`]: p || e
    },
    i
  ), j = (m) => {
    p || e ? m.preventDefault() : f && f(m);
  }, x = !!$["aria-disabled"] || p || e;
  return /* @__PURE__ */ S(
    "button",
    {
      className: h,
      "data-testid": n,
      type: O,
      ref: l,
      "aria-disabled": x,
      onClick: j,
      ...$,
      children: [
        e && /* @__PURE__ */ o(yt, { size: b === dt.LG ? "xs" : "xxs", negative: u, disabled: x }),
        " ",
        t
      ]
    }
  );
}, Gr = Q(zt);
Gr.displayName = "Button";
function Ot(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var dr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var fr;
function Nt() {
  return fr || (fr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(dr)), dr.exports;
}
var At = Nt();
const Mt = /* @__PURE__ */ Ot(At), Pt = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, kt = Mt.bind(Pt), vr = "purpur-icon", Ct = "md", Bt = (t) => t.filter((i) => Object.keys(i).length >= 1).map((i) => `${i.name}="${i.value}"`).join(" "), Rt = ({ content: t = "", title: i } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    i ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], p = i ? `<title>${i}</title>` : "";
  return `<svg ${Bt(n)}>${p}${t}</svg>`;
}, Dt = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Wr = ({
  ["data-testid"]: t,
  svg: i,
  allyTitle: n,
  className: p,
  size: a = Ct,
  ...r
}) => {
  const e = Rt({
    content: Dt(i.svg),
    title: n
  }), u = kt(p, vr, `${vr}--${a}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: u,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
Wr.displayName = "Icon";
const It = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function Lt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var gr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var br;
function Et() {
  return br || (br = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(gr)), gr.exports;
}
var Ft = Et();
const Vt = /* @__PURE__ */ Lt(Ft), mr = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, xr = "purpur-field-error-text", Zt = ({
  children: t,
  className: i,
  ["aria-relevant"]: n = "additions text",
  ...p
}) => /* @__PURE__ */ S(
  "div",
  {
    className: Vt([i, mr[xr]]),
    "aria-live": "assertive",
    "aria-relevant": n,
    ...p,
    children: [
      /* @__PURE__ */ o(Wr, { svg: It, size: "xs", className: mr[`${xr}__icon`] }),
      t
    ]
  }
);
function Ht(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var yr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hr;
function Tt() {
  return hr || (hr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(yr)), yr.exports;
}
var Gt = Tt();
const Wt = /* @__PURE__ */ Ht(Gt), wr = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, $r = "purpur-field-helper-text", Qt = ({
  children: t,
  className: i,
  disabled: n,
  id: p,
  ...a
}) => {
  const r = Wt([
    i,
    wr[$r],
    {
      [wr[`${$r}--disabled`]]: n
    }
  ]);
  return /* @__PURE__ */ o("span", { id: p, className: r, ...a, children: t });
};
function Ut(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var jr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var qr;
function Xt() {
  return qr || (qr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(jr)), jr.exports;
}
var Yt = Xt();
const Jt = /* @__PURE__ */ Ut(Yt), Kt = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, re = Jt.bind(Kt), Sr = "purpur-icon", te = "md", ee = (t) => t.filter((i) => Object.keys(i).length >= 1).map((i) => `${i.name}="${i.value}"`).join(" "), ne = ({ content: t = "", title: i } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    i ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], p = i ? `<title>${i}</title>` : "";
  return `<svg ${ee(n)}>${p}${t}</svg>`;
}, ue = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), rr = ({
  ["data-testid"]: t,
  svg: i,
  allyTitle: n,
  className: p,
  size: a = te,
  ...r
}) => {
  const e = ne({
    content: ue(i.svg),
    title: n
  }), u = re(p, Sr, `${Sr}--${a}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: u,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
rr.displayName = "Icon";
const ie = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, Qr = (t) => /* @__PURE__ */ o(rr, { ...t, svg: ie });
Qr.displayName = "IconCheckCircleFilled";
const ae = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, Ur = (t) => /* @__PURE__ */ o(rr, { ...t, svg: ae });
Ur.displayName = "IconClose";
function zr(t, i) {
  if (typeof t == "function")
    return t(i);
  t != null && (t.current = i);
}
function pe(...t) {
  return (i) => {
    let n = !1;
    const p = t.map((a) => {
      const r = zr(a, i);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let a = 0; a < p.length; a++) {
          const r = p[a];
          typeof r == "function" ? r() : zr(t[a], null);
        }
      };
  };
}
var Xr = _.forwardRef((t, i) => {
  const { children: n, ...p } = t, a = _.Children.toArray(n), r = a.find(le);
  if (r) {
    const e = r.props.children, u = a.map((f) => f === r ? _.Children.count(e) > 1 ? _.Children.only(null) : _.isValidElement(e) ? e.props.children : null : f);
    return /* @__PURE__ */ o(K, { ...p, ref: i, children: _.isValidElement(e) ? _.cloneElement(e, void 0, u) : null });
  }
  return /* @__PURE__ */ o(K, { ...p, ref: i, children: n });
});
Xr.displayName = "Slot";
var K = _.forwardRef((t, i) => {
  const { children: n, ...p } = t;
  if (_.isValidElement(n)) {
    const a = ce(n), r = se(p, n.props);
    return n.type !== _.Fragment && (r.ref = i ? pe(i, a) : a), _.cloneElement(n, r);
  }
  return _.Children.count(n) > 1 ? _.Children.only(null) : null;
});
K.displayName = "SlotClone";
var oe = ({ children: t }) => /* @__PURE__ */ o(Tr, { children: t });
function le(t) {
  return _.isValidElement(t) && t.type === oe;
}
function se(t, i) {
  const n = { ...i };
  for (const p in i) {
    const a = t[p], r = i[p];
    /^on[A-Z]/.test(p) ? a && r ? n[p] = (...e) => {
      r(...e), a(...e);
    } : a && (n[p] = a) : p === "style" ? n[p] = { ...a, ...r } : p === "className" && (n[p] = [a, r].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function ce(t) {
  var i, n;
  let p = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, a = p && "isReactWarning" in p && p.isReactWarning;
  return a ? t.ref : (p = (n = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : n.get, a = p && "isReactWarning" in p && p.isReactWarning, a ? t.props.ref : t.props.ref || t.ref);
}
var _e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], de = _e.reduce((t, i) => {
  const n = _.forwardRef((p, a) => {
    const { asChild: r, ...e } = p, u = r ? Xr : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ o(u, { ...e, ref: a });
  });
  return n.displayName = `Primitive.${i}`, { ...t, [i]: n };
}, {}), fe = "Label", Yr = _.forwardRef((t, i) => /* @__PURE__ */ o(
  de.label,
  {
    ...t,
    ref: i,
    onMouseDown: (n) => {
      var p;
      n.target.closest("button, input, select, textarea") || ((p = t.onMouseDown) == null || p.call(t, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Yr.displayName = fe;
var ve = Yr;
function ge(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Or = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Nr;
function be() {
  return Nr || (Nr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(Or)), Or.exports;
}
var me = be();
const xe = /* @__PURE__ */ ge(me), X = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, Y = "purpur-label", ye = ({
  children: t,
  className: i,
  disabled: n,
  negative: p = !1,
  ...a
}) => {
  const r = xe([
    i,
    X[Y],
    {
      [X[`${Y}--disabled`]]: n,
      [X[`${Y}--negative`]]: p
    }
  ]);
  return /* @__PURE__ */ o(ve, { className: r, ...a, children: t });
};
function he(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ar = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Mr;
function we() {
  return Mr || (Mr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(Ar)), Ar.exports;
}
var $e = we();
const Pr = /* @__PURE__ */ he($e), je = "_rotate_1xozj_1", qe = "_dash_1xozj_1", V = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: je,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: qe,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, Z = "purpur-spinner", Se = {
  SM: "sm"
}, ze = ({
  ["data-testid"]: t,
  disabled: i = !1,
  negative: n = !1,
  size: p = Se.SM,
  ...a
}) => /* @__PURE__ */ o(
  "div",
  {
    className: Pr([V[Z], V[`${Z}--${p}`]]),
    "data-testid": t,
    ...a,
    children: /* @__PURE__ */ o("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ o(
      "circle",
      {
        className: Pr(V[`${Z}__circle`], {
          [V[`${Z}__circle--disabled`]]: i,
          [V[`${Z}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Oe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var kr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Cr;
function Ne() {
  return Cr || (Cr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(kr)), kr.exports;
}
var Ae = Ne();
const Me = /* @__PURE__ */ Oe(Ae), Pe = {
  "purpur-text-field": "_purpur-text-field_3gl1k_1",
  "purpur-text-field__label": "_purpur-text-field__label_3gl1k_7",
  "purpur-text-field__label-text": "_purpur-text-field__label-text_3gl1k_12",
  "purpur-text-field__field-row": "_purpur-text-field__field-row_3gl1k_15",
  "purpur-text-field__frame": "_purpur-text-field__frame_3gl1k_19",
  "purpur-text-field__input-container": "_purpur-text-field__input-container_3gl1k_26",
  "purpur-text-field__input-container--disabled": "_purpur-text-field__input-container--disabled_3gl1k_37",
  "purpur-text-field__input-container--readonly": "_purpur-text-field__input-container--readonly_3gl1k_40",
  "purpur-text-field__input-container--has-clear-button": "_purpur-text-field__input-container--has-clear-button_3gl1k_43",
  "purpur-text-field__input-container--end-adornment": "_purpur-text-field__input-container--end-adornment_3gl1k_46",
  "purpur-text-field__input": "_purpur-text-field__input_3gl1k_26",
  "purpur-text-field__input-container--start-adornment": "_purpur-text-field__input-container--start-adornment_3gl1k_52",
  "purpur-text-field__input--valid": "_purpur-text-field__input--valid_3gl1k_94",
  "purpur-text-field__input--error": "_purpur-text-field__input--error_3gl1k_94",
  "purpur-text-field__adornment-container": "_purpur-text-field__adornment-container_3gl1k_106",
  "purpur-text-field__valid-icon": "_purpur-text-field__valid-icon_3gl1k_111"
}, ke = (t) => it(t), q = Me.bind(Pe), c = "purpur-text-field", Ce = ({
  ["data-testid"]: t,
  className: i,
  clearButtonAriaLabel: n,
  beforeField: p,
  afterField: a,
  endAdornment: r,
  errorText: e,
  helperText: u,
  label: f,
  loading: b = !1,
  onClear: v,
  startAdornment: O,
  valid: $ = !1,
  ...l
}, h) => {
  var j;
  const x = ut(), m = l.id ?? x, s = (d) => t ? `${t}-${d}` : void 0, z = $ && !e, k = u ? `${m}-helper-text` : void 0, y = [O].filter((d) => !!d), C = (typeof l.value == "number" ? l.value !== void 0 : (j = l.value) == null ? void 0 : j.length) && !l.disabled && !l.readOnly && !b && v && n, B = ke(null), N = (d) => {
    B.current = d, typeof h == "function" ? h(d) : h && (h.current = d);
  }, A = () => {
    var d;
    v == null || v(), (d = B.current) == null || d.focus();
  }, D = [
    b && /* @__PURE__ */ o(
      ze,
      {
        disabled: l.disabled,
        size: "xs",
        "data-testid": s("spinner")
      },
      "spinner"
    ),
    C && /* @__PURE__ */ o(
      Gr,
      {
        variant: "tertiary-purple",
        onClick: A,
        iconOnly: !0,
        "aria-label": n ?? "",
        "data-testid": s("clear-button"),
        tabIndex: -1,
        children: /* @__PURE__ */ o(Ur, { size: "xs" })
      },
      "clear-button"
    ),
    z && /* @__PURE__ */ o(
      Qr,
      {
        "data-testid": s("valid-icon"),
        className: q(`${c}__valid-icon`)
      },
      "valid-icon"
    )
  ].filter((d) => !!d), U = q([
    `${c}__input-container`,
    {
      [`${c}__input-container--start-adornment`]: y.length,
      [`${c}__input-container--end-adornment`]: D.length || r,
      [`${c}__input-container--disabled`]: l.disabled,
      [`${c}__input-container--has-clear-button`]: C,
      [`${c}__input-container--readonly`]: l.readOnly && !l.disabled
    }
  ]);
  return /* @__PURE__ */ S("div", { className: q(i, c), children: [
    f && /* @__PURE__ */ S(
      ye,
      {
        htmlFor: m,
        className: q(`${c}__label`),
        "data-testid": s("label"),
        disabled: l.disabled,
        children: [
          l.required && /* @__PURE__ */ o("span", { "aria-hidden": !0, children: "*" }),
          f
        ]
      }
    ),
    /* @__PURE__ */ S("div", { className: q(`${c}__field-row`), children: [
      !!p && p,
      /* @__PURE__ */ S("div", { className: U, children: [
        !!y.length && /* @__PURE__ */ o(
          "div",
          {
            "data-testid": s("start-adornments"),
            className: q(`${c}__adornment-container`),
            children: y
          }
        ),
        /* @__PURE__ */ o(
          "input",
          {
            ...l,
            id: m,
            ref: N,
            "data-testid": s("input"),
            "aria-describedby": l["aria-describedby"] || k,
            "aria-invalid": l["aria-invalid"] || !!e,
            className: q([
              `${c}__input`,
              {
                [`${c}__input--valid`]: z,
                [`${c}__input--error`]: !!e
              }
            ])
          }
        ),
        /* @__PURE__ */ o("div", { className: q(`${c}__frame`) }),
        (!!D.length || r) && /* @__PURE__ */ S(
          "div",
          {
            "data-testid": s("end-adornments"),
            className: q(`${c}__adornment-container`),
            children: [
              D,
              r
            ]
          }
        )
      ] }),
      !!a && a
    ] }),
    k && /* @__PURE__ */ o(Qt, { "data-testid": s("helper-text"), id: k, children: u }),
    e && /* @__PURE__ */ o(Zt, { "data-testid": s("error-text"), children: e })
  ] });
}, Jr = Q(Ce);
Jr.displayName = "TextField";
function Be(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var J = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Br;
function Re() {
  return Br || (Br = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(J)), J.exports;
}
var De = Re();
const Kr = /* @__PURE__ */ Be(De), Ie = {
  "purpur-quantity-selector": "_purpur-quantity-selector_lzxe3_1",
  "purpur-quantity-selector--full-width": "_purpur-quantity-selector--full-width_lzxe3_21",
  "purpur-quantity-selector--loading": "_purpur-quantity-selector--loading_lzxe3_27",
  "purpur-quantity-selector--no-gap": "_purpur-quantity-selector--no-gap_lzxe3_30",
  "purpur-quantity-selector--no-gap-disabled-left": "_purpur-quantity-selector--no-gap-disabled-left_lzxe3_35",
  "purpur-quantity-selector--no-gap-disabled-right": "_purpur-quantity-selector--no-gap-disabled-right_lzxe3_39",
  "purpur-quantity-selector--no-gap-disabled": "_purpur-quantity-selector--no-gap-disabled_lzxe3_35",
  "purpur-quantity-selector__spinner": "_purpur-quantity-selector__spinner_lzxe3_46",
  "purpur-quantity-selector__spinner--full-width": "_purpur-quantity-selector__spinner--full-width_lzxe3_53",
  "purpur-quantity-selector__spinner--separated": "_purpur-quantity-selector__spinner--separated_lzxe3_57"
}, Le = {
  LG: "lg"
};
function Ee(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Rr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Dr;
function Fe() {
  return Dr || (Dr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p(u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(Rr)), Rr.exports;
}
var Ve = Fe();
const Ir = /* @__PURE__ */ Ee(Ve), Ze = "_rotate_1xozj_1", He = "_dash_1xozj_1", H = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Ze,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: He,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, T = "purpur-spinner", Te = {
  SM: "sm"
}, Ge = ({
  ["data-testid"]: t,
  disabled: i = !1,
  negative: n = !1,
  size: p = Te.SM,
  ...a
}) => /* @__PURE__ */ o(
  "div",
  {
    className: Ir([H[T], H[`${T}--${p}`]]),
    "data-testid": t,
    ...a,
    children: /* @__PURE__ */ o("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ o(
      "circle",
      {
        className: Ir(H[`${T}__circle`], {
          [H[`${T}__circle--disabled`]]: i,
          [H[`${T}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function We(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Lr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Er;
function Qe() {
  return Er || (Er = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(Lr)), Lr.exports;
}
var Ue = Qe();
const Xe = /* @__PURE__ */ We(Ue), Ye = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Je = Xe.bind(Ye), P = "purpur-button", Ke = ({
  children: t,
  className: i,
  ["data-testid"]: n,
  disabled: p = !1,
  fullWidth: a = !1,
  iconOnly: r,
  loading: e = !1,
  negative: u = !1,
  onClick: f,
  size: b = "md",
  variant: v,
  type: O = "button",
  ...$
}, l) => {
  if (r && v === "destructive")
    return null;
  const h = Je(
    [
      P,
      `${P}--${u ? `${v}-negative` : v}`,
      `${P}--${b}`
    ],
    {
      [`${P}--icon-only`]: r,
      [`${P}--negative`]: u,
      [`${P}--full-width`]: a,
      [`${P}--disabled`]: p || e
    },
    i
  ), j = (m) => {
    p || e ? m.preventDefault() : f && f(m);
  }, x = !!$["aria-disabled"] || p || e;
  return /* @__PURE__ */ S(
    "button",
    {
      className: h,
      "data-testid": n,
      type: O,
      ref: l,
      "aria-disabled": x,
      onClick: j,
      ...$,
      children: [
        e && /* @__PURE__ */ o(Ge, { size: b === Le.LG ? "xs" : "xxs", negative: u, disabled: x }),
        " ",
        t
      ]
    }
  );
}, rt = Q(Ke);
rt.displayName = "Button";
function rn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Fr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Vr;
function tn() {
  return Vr || (Vr = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var u = arguments[e];
          u && (r = a(r, p.call(this, u)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var u in r)
          i.call(r, u) && r[u] && (e = a(e, this && this[u] || u));
        return e;
      }
      function a(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(Fr)), Fr.exports;
}
var en = tn();
const nn = /* @__PURE__ */ rn(en), un = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, an = nn.bind(un), Zr = "purpur-icon", pn = "md", on = (t) => t.filter((i) => Object.keys(i).length >= 1).map((i) => `${i.name}="${i.value}"`).join(" "), ln = ({ content: t = "", title: i } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    i ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], p = i ? `<title>${i}</title>` : "";
  return `<svg ${on(n)}>${p}${t}</svg>`;
}, sn = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), tr = ({
  ["data-testid"]: t,
  svg: i,
  allyTitle: n,
  className: p,
  size: a = pn,
  ...r
}) => {
  const e = ln({
    content: sn(i.svg),
    title: n
  }), u = an(p, Zr, `${Zr}--${a}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: u,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
tr.displayName = "Icon";
const cn = {
  name: "minus",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.1 12a.9.9 0 0 1 .9-.9h14a.9.9 0 1 1 0 1.8H5a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["minus"],
  category: "utility"
}, tt = (t) => /* @__PURE__ */ o(tr, { ...t, svg: cn });
tt.displayName = "IconMinus";
const _n = {
  name: "plus",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 4.1a.9.9 0 0 1 .9.9v6.1H19a.9.9 0 1 1 0 1.8h-6.1V19a.9.9 0 0 1-1.8 0v-6.1H5a.9.9 0 0 1 0-1.8h6.1V5a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["plus"],
  category: "utility"
}, et = (t) => /* @__PURE__ */ o(tr, { ...t, svg: _n });
et.displayName = "IconPlus";
const dn = {
  "purpur-quantity-selector-button": "_purpur-quantity-selector-button_qjlbs_1",
  "purpur-quantity-selector-button--gap-left": "_purpur-quantity-selector-button--gap-left_qjlbs_4",
  "purpur-quantity-selector-button--gap-right": "_purpur-quantity-selector-button--gap-right_qjlbs_7",
  "purpur-quantity-selector-button--no-gap-right": "_purpur-quantity-selector-button--no-gap-right_qjlbs_10",
  "purpur-quantity-selector-button--no-gap-left": "_purpur-quantity-selector-button--no-gap-left_qjlbs_13"
}, fn = Kr.bind(dn), G = "purpur-quantity-selector-button", vn = ({
  ["data-testid"]: t,
  disabled: i,
  hasGap: n,
  variant: p,
  buttonType: a,
  onClick: r
}) => {
  const e = fn([
    G,
    {
      [`${G}--gap-left`]: n && a === "decrement",
      [`${G}--gap-right`]: n && a === "increment",
      [`${G}--no-gap-left`]: !n && a === "decrement",
      [`${G}--no-gap-right`]: !n && a === "increment"
    }
  ]);
  return /* @__PURE__ */ o(
    rt,
    {
      "data-testid": t,
      className: e,
      size: "sm",
      type: "submit",
      variant: p,
      onClick: () => r(a),
      iconOnly: !0,
      disabled: i,
      tabIndex: -1,
      children: a === "increment" ? /* @__PURE__ */ o(et, { size: "xs" }) : /* @__PURE__ */ o(tt, { size: "xs" })
    }
  );
}, Hr = Kr.bind(Ie), yn = ["attached", "separated"], hn = ["primary", "secondary"], w = "purpur-quantity-selector", gn = Q(
  ({
    ["data-testid"]: t,
    className: i,
    variant: n,
    buttonVariant: p,
    onChange: a,
    value: r,
    defaultValue: e,
    fullWidth: u,
    disabled: f,
    loading: b,
    minValue: v,
    maxValue: O,
    ...$
  }, l) => {
    const [h, j] = nr(e ?? 0), [x, m] = nr(h), s = r !== void 0, z = s ? r : x, k = (g) => t ? `${t}-${g}` : void 0, y = f || b, C = Math.max(v ?? 0, 0), B = O ?? Number.MAX_SAFE_INTEGER, N = z === B, A = z === C;
    ur(() => {
      s && j(r);
    }, [r, s]), ur(() => {
      if (!s) {
        const g = setTimeout(() => {
          j(x);
        }, 300);
        return () => clearTimeout(g);
      }
    }, [x, s, a]);
    const D = Hr([
      i,
      w,
      {
        [`${w}--no-gap`]: n === "attached" && !y && !A && !N,
        [`${w}--no-gap-disabled-left`]: n === "attached" && !y && !N && A,
        [`${w}--no-gap-disabled-right`]: n === "attached" && !y && !A && N,
        [`${w}--no-gap-disabled`]: n === "attached" && (y || N && A),
        [`${w}--full-width`]: u,
        [`${w}--loading`]: b
      }
    ]), U = (g) => {
      if (!/^[0-9]*$/.test(g.target.value))
        return;
      const W = +g.target.value;
      W < C || W > B || (s || m(W), a(W));
    }, d = (g) => {
      const R = g === "increment" ? z + 1 : z - 1;
      R < 0 || (s || m(R), a(R));
    }, er = (g) => {
      const R = g === "increment" && N || g === "decrement" && A;
      return /* @__PURE__ */ o(
        vn,
        {
          "data-testid": k("button-" + g),
          variant: p,
          buttonType: g,
          hasGap: n === "separated",
          onClick: d,
          disabled: y || R
        }
      );
    }, nt = /* @__PURE__ */ S(Tr, { children: [
      b && /* @__PURE__ */ o(
        "div",
        {
          className: Hr([
            `${w}__spinner`,
            {
              [`${w}__spinner--full-width`]: u,
              [`${w}__spinner--separated`]: !u && n === "separated"
            }
          ]),
          children: /* @__PURE__ */ o(
            _t,
            {
              disabled: y,
              size: "xs",
              "data-testid": k("spinner")
            },
            "spinner"
          )
        }
      ),
      er("decrement")
    ] });
    return /* @__PURE__ */ o(
      Jr,
      {
        value: z,
        type: "number",
        ref: l,
        className: D,
        "data-testid": t,
        onChange: U,
        beforeField: nt,
        afterField: er("increment"),
        disabled: y,
        min: C,
        max: B,
        ...$
      }
    );
  }
);
gn.displayName = "QuantitySelector";
export {
  gn as QuantitySelector,
  hn as quantitySelectorButtonVariants,
  yn as quantitySelectorVariants
};
//# sourceMappingURL=quantity-selector.es.js.map
